import {
  SA_CHARGE_PRODUCTS,
  SA_CHARGE_VARIANT_MAPPING,
  SA_SWAP_PRODUCT_MAPPING,
} from '../../constants/selfActivationProducts';

export const needChargeForProduct = (sub) => {
  return SA_CHARGE_PRODUCTS.includes(sub?.external_product_id?.ecommerce);
};

export const mapSaSwapProducts = (productId) => {
  return SA_SWAP_PRODUCT_MAPPING[productId] || productId;
};

export const mapSaChargeVariant = (variantId) => {
  return SA_CHARGE_VARIANT_MAPPING[variantId] || variantId;
};

export const isChargeForThatProductVariant = (charge, variantId) =>
  !!charge?.line_items?.find(
    (item) => item?.external_variant_id?.ecommerce === variantId,
  );

export const filterSubCharges = (charges, subId) => {
  if (!charges) {
    return [];
  }
  return charges.filter((charge) =>
    charge.line_items.find((item) => item.purchase_item_id === subId),
  );
};

export const findVariantCharge = (charges, subId, productVariantId, status) => {
  if (!charges) {
    return null;
  }

  return charges
    .filter((charge) => charge.status === status)
    .find((charge) =>
      charge.line_items.find(
        (item) =>
          item.purchase_item_id === subId &&
          item.external_variant_id?.ecommerce ===
            mapSaChargeVariant(productVariantId).toString(),
      ),
    );
};
